var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.375 12.6h-6.9v1.35h6.9v-1.35zm3.45 4.35v-10.8c0-0.3-0.075-0.675-0.3-0.9-1.425-1.65-2.925-3.15-4.5-4.575-0.225-0.225-0.525-0.375-0.9-0.375h-7.275c-0.375 0-0.675 0.3-0.675 0.675v16.125c0 0.375 0.3 0.675 0.675 0.675h12.375c0.3-0.15 0.6-0.45 0.6-0.825zm-1.275-0.6h-11.1v-14.85h5.925c0.3 0 0.975 0.225 0.975 1.5v2.1c0 0.3 0.225 0.6 0.6 0.6h2.025c1.35 0 1.5 0.75 1.5 1.05v9.6h0.075zm-2.175-6.225h-6.9v1.35h6.9v-1.35zm0-2.475h-6.9v1.35h6.9v-1.35z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contractIcon.bf31e8b8c4ed1ff2eecd523f82802f23.svg";
export { ForwardRef as ReactComponent };